<template>
  <tr
    :key="`${isSuggested}${item.id}${item.doctor_id}`"
    class="result-row"
    :class="{
      'expanded-row': isEmailRowVisible,
      suggested: isSuggested,
    }"
    :data-v-tour="item.is_example ? 'examplePractice' : ''"
  >
    <td>
      <div class="" style="min-width: 0; position: relative; display: grid">
        <div class="badge badge-light" v-if="isSpecialtyVisible" style="position: absolute; margin-top: -25px">
          {{ PracticeTypes[item.specialty] }}
        </div>
        <div class="overlay-row" v-if="!isInNetwork" :class="{ 'p-2': isEmailRowVisible }">
          <add-email-row
            :practice="item"
            :redirect="redirect"
            :visible="isEmailRowVisible"
            :preventInvite="true"
            :data-v-tour="item.is_example ? 'examplePracticeEmail' : ''"
            @adding="isAddingToNetwork = true"
            @added="addedToNetwork"
            @close="isEmailRowVisible = false"
            :class="{ 'z-index-for-tour': item.is_example }"
          />
        </div>
        <div class="overlay-row p-2" style="background: var(--primary-color-20)" v-if="!isInNetwork && item.email">
          <font-awesome-icon icon="spinner-third" class="text-primary mx-auto" spin size="2x" />
        </div>
        <!--TODO: Should make this row a component that can be shared with the table below-->
        <div class="d-flex flex-row overflow-hidden" style="min-width: 0">
          <div class="align-self-center flex-grow-1 overflow-hidden" style="min-width: 0">
            <div class="d-flex flex-row justify-content-between overflow-hidden" style="min-width: 0">
              <div class="flex-grow-1 overflow-hidden mr-3" style="min-width: 0; width: 45%">
                <div class="d-flex align-items-center overflow-hidden" style="min-width: 0">
                  <small
                    v-if="isSuggested"
                    class="text-primary text-uppercase mr-2 border border-primary"
                    style="padding: 0.375em 0.75em; font-size: 0.75em"
                    >suggested</small
                  >
                  <img
                    v-if="isSuggested && item.status == 1"
                    src="../../assets/svg/logo.svg"
                    style="width: 15px"
                    class="mr-2"
                    alt="Active on Refera"
                    title="Active on Refera"
                  />
                  <span class="font-weight-bolder text-capitalize item-name text-overflow" style="font-size: 1rem">{{
                    item.name
                  }}</span>

                  <small v-if="typeof item.distance === 'number'" class="text-muted ml-2 text-lowercase text-nowrap"
                    >{{ parseFloat(item.distance.toFixed(1)) }} mi</small
                  >
                  <!-- <small v-if="item.last_referral_time" class="ml-auto mr-5 text-muted">Last referral sent
                                      {{
                                        moment(
                                          item.last_referral_time
                                        ).fromNow()
                                      }}</small> -->
                </div>
                <div class="d-flex flex-row item-meta overflow-hidden" style="min-width: 0; font-size: 0.95rem">
                  <div class="pr-3 item-specialty" v-if="isSpecialtyVisible && false">
                    <small class="text-muted text-truncate text-uppercase d-block">{{
                      PracticeTypes[item.specialty]
                    }}</small>
                  </div>
                  <div class="pr-3 item-website d-none" v-if="item.website">
                    <small class="text-muted text-truncate d-block">
                      <font-awesome-icon icon="globe" class="mr-1 text-muted" />&nbsp;
                      <a :href="item.website" target="_blank">Website</a>
                    </small>
                  </div>
                  <div class="pr-3 item-phone" v-if="item.phone">
                    <small class="text-muted text-truncate d-block">
                      <font-awesome-icon icon="phone" class="mr-1 text-muted" />
                      &nbsp;{{ item.phone | phone }}
                    </small>
                  </div>
                  <div class="pr-3 item-address overflow-hidden" v-if="address.length" style="_display: inline-grid">
                    <small class="text-muted text-truncate text-capitalize text-nowrap d-block">
                      <font-awesome-icon v-if="address.length" icon="map-marker-alt" class="mr-1 text-muted" />
                      {{ address.join(', ').toLowerCase() }}
                    </small>
                  </div>
                </div>
              </div>
              <div
                class="doctor-list-container mr-5 d-flex align-items-center text-left justify-content-start"
                style="width: 30%; font-size: 0.75rem"
              >
                <doctor-list :doctors="item.doctors" />
              </div>
              <div class="d-flex align-items-center">
                <a
                  v-if="isSelected"
                  href="javascript:void(0)"
                  @click="selected(item)"
                  class="btn btn-primary btn-lg btn-thick mx-auto align-self-center"
                  >Selected</a
                >
                <a
                  v-else-if="isInNetwork"
                  href="javascript:void(0)"
                  @click="selected(item)"
                  class="btn btn-outline-primary btn-lg btn-thick mx-auto align-self-center"
                  >Select</a
                >
                <a
                  v-else
                  href="javascript:void(0)"
                  @click="addPractice"
                  class="btn btn-outline-primary btn-lg btn-thick mx-auto align-self-center"
                  :class="{ 'bg-light': item.is_example }"
                  :data-v-tour="item.is_example ? 'examplePracticeSelect' : ''"
                >
                  <font-awesome-icon icon="spinner-third" spin v-if="isAddingToNetwork" />
                  <span v-else>{{ addToNetworkBtnText || 'Select' }}</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </td>
  </tr>
</template>

<script>
import AddEmailRow from '@/components/network/AddEmailRow'
import sort from 'fast-sort'
import { mapGetters } from 'vuex'
import DoctorList from './DoctorList.vue'
export default {
  props: ['item', 'redirect', 'isSpecialtyVisible', 'isSelected', 'addToNetworkBtnText'],
  components: { AddEmailRow, DoctorList },
  data() {
    return {
      isSuggested: false,
      isAddingToNetwork: false,
      isEmailRowVisible: false,
      isSelectingPractice: false,
      isNowInNetwork: false,
    }
  },
  async created() {
    if (!this.$store.state.practices.isLoaded && !this.$store.state.practices.isLoading) {
      await this.$store.dispatch('practices/load')
    }
  },
  computed: {
    ...mapGetters('practices', ['network']),
    ...mapGetters('settings', ['PracticeTypes']),
    address() {
      return [this.item.address, this.item.address_2, this.item.city].filter((s) => s)
    },
    isInNetwork() {
      return this.isNowInNetwork || this.network.some((p) => p.id == this.item.id)
    },
  },
  methods: {
    addedToNetwork({ practice, network }) {
      this.isAddingToNetwork = false
      this.addEmailRowVisibleId = null
      this.isNowInNetwork = true
      this.$emit('selected', { practice: practice, isAddedToNetwork: true })
    },
    async addPractice() {
      if (this.isSelectingPractice || this.isAddingToNetwork) return
      let practice = this.item

      if (practice.is_example) {
        this.$emit('adding', { practice: this.item })
        this.addedToNetwork({
          practice,
        })
        await this.$store.commit('suggested/removeTour')
        return
      }
      const isEmailPresent = !!practice.email
      const isEmailessAllowed = this.redirect != 'op-report'
      if (!this.isInNetwork && (isEmailessAllowed || isEmailPresent)) {
        try {
          this.isAddingToNetwork = true
          this.isSelectingPractice = true
          const network = await this.$store.dispatch('practices/addToNetwork', {
            ...practice,
          })
          this.addedToNetwork({ practice, network })
        } catch (err) {
          this.$helpers.handleApiError(this)(err)
        }
        this.isAddingToNetwork = false
        this.isSelectingPractice = false
      }
      this.isEmailRowVisible = !isEmailPresent
    },
    selected(practice) {
      this.$emit('selected', { practice, isAddedToNetwork: false })
    },
  },
}
</script>

<style scoped>
.btn-outline-primary.bg-light:hover {
  background: var(--primary-color) !important; /*fix for tour applied bg-light */
}
</style>